/**
 * Directional orbit left (counter-clockwise) gesture
 * @module gestures/transforms/orbitLeft
 */
import { createOrbitGesture } from './orbitFactory.js';
export default createOrbitGesture('left');
